import type { SquareInfo } from '@/components/Game/GameGrid/SquareContent';
import type { GameThemeId, Coordinates } from '@skillscratch/shared-types';
import { createContext, type ReactNode } from 'react';

export type GameStatus = "no-scratch" | "no-time" | "found-all-treasures" | "ready-to-start" | "playing";

export interface GameStateContextType {
  gameStatus: GameStatus;
  showBoardLoading: boolean;
  timerStartTime: number;
  bonusScratches: number | null;
  bonusBombs: number | null;
  showBonusScratchesModal: boolean;
  showBonusBombsModal: boolean;
  scratchesLeft: number;
  treasureFoundCount: number;
  handleSquareReveal: (coordinates: Coordinates) => void;
  activateBonusScratches: () => void;
  activateBonusBombs: (numberOfSquares: number) => Promise<number>;

  onTimeUp: () => void;
  cardName: GameThemeId;
}

export interface GameStateProviderProps {
  children: ReactNode;
  grid: SquareInfo[][];
  scratchLimit: number;
  treasureCount: number;
  onSquareReveal: (coordinates: Coordinates) => void;
  onGameEnd: (reason: "no-scratch" | "no-time" | "found-all-treasures") => Promise<void>;
  cardName: GameThemeId;
}

export const GameStateContext = createContext<GameStateContextType | null>(null);